import { EventTarget } from 'cc';
import Game from '../Game';
import Delay from '../Toolkit/Utils/Delay';

export enum GlobalInstanceEnum {
    game = 'game',
    bonus = 'bonus',
}

export enum GlobalInstanceEvent {
    Register = 'register',
}

class GlobalInstance extends EventTarget {
    public static readonly EVENT_TYPE = GlobalInstanceEvent;

    private _games: {
        [key: string]: Game;
        game: Game;
        bonus: globalThis.BonusModule;
    } = {
        game: null,
        bonus: null,
    };

    public get game() {
        return this._games.game;
    }

    public get games() {
        return this._games;
    }

    public registerGame(name: string, game: Game) {
        this._games[name] = game;
        game.waitForLaunched.then(() => {
            if (game.config.debug) {
                // for debug convenience in devtools console, not for global access
                (window as any)[name] = game;
            }
        });
        this.emit(GlobalInstance.EVENT_TYPE.Register, name);
    }

    public waitForGameRegistered(name: string) {
        if (this._games[name]) {
            return Promise.resolve();
        }
        return Delay.event(GlobalInstance.EVENT_TYPE.Register, this);
    }
}

const globalInstance = new GlobalInstance();
export default globalInstance;
